<template>
  <div class="home">
    <!-- ref的dom元素获取div,把画布添加到div里面 -->
    <div class="canvas-container" ref="screenDom"></div>
    <div class="header">
      <div class="logo"></div>
      <div class="menu">
        <a href="href" class="menuItem">3D Design</a>
        <a
          href="href"
          class="menuItem"
          >Website</a
        >
        <a href="href" class="menuItem">Dapp</a>
      </div>
    </div>
    <div class="pages" ref="pages">
      <div class="page1">
        <h2 class="title">DOADesigner</h2>
        <p>Subscriptions to scale your business</p>
      </div>
      <div class="page">
        <h2 class="title">Benefits</h2>
        <p>What's included:</p>
        <div class="pricing__col-bottom">
          <div class="pricing__col-bottom-bottom">
            <div class="pricing__included"></div>
            <ul role="list" class="pricing__list">
              <li class="pricing__li">
                Partnership
                <div>Earn 10-20% monthly recurring commissions for each referral. or team work for more</div>
              </li>
              <li class="pricing__li">
                Flexible and scalable
                <div>Scale up or down when needed and Pause or cancel anytime.</div>
              </li>
              <li class="pricing__li">
                Lightning fast delivery
                <div>Get your design one at a time in just a few days on average.</div>
              </li>

              <li class="pricing__li">
                Unique and all yours
                <div>Each of your designs is made especially for you and is 100% yours.</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="page">
        <h2 class="title">Scope of work</h2>
        <p> 3D Video, Website, Dapps, Writing and more.</p>
        <div class="pricing__col-bottom">
          <div class="pricing__col-bottom-bottom">
            <div class="pricing__included"></div>
            <ul role="list" class="pricing__list">
              <li class="pricing__li">
                3D Design
                <div>, Animation, Video effects and editing, Digital ads, Logos & branding.</div>
              </li>
              <li class="pricing__li">
                3D Website
                <div>3d website for Metaverse, Digital twin/model, Smart cities/companies, 3D visualization</div>
              </li>
              <li class="pricing__li">
                Writing
                <div>Translation, SCI writing, Financial research, CFA 3 level candidates.</div>
              </li>
              <li class="pricing__li">
                Dapp
                <div>3d App, Decentralized App, Solidity Develop</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="page">
        <h2 class="title">Recent work</h2>
        <p>Design Video </p>
        <video
        id="myVideo"
        class="video-js"
        controls
        preload="auto"
        width="1000"
      
        poster="MY_VIDEO_POSTER.jpg"
        data-setup="{}">
        <source
          src="./assets/sample.mp4"
          type="video/mp4" 
          preload="auto" 
                       
          >
        </video>


        <!-- <div class="content_video">
          <div class="content_video"> -->
            <!-- 使用组件video-player -->
            <!-- <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            ></video-player>
          </div>
        </div> -->
      </div>
      <div class="page">
        <h2 class="title">Memberships levels</h2>
        <p>Choose a plan for you.</p>
        <div class="same-height-columns">

         <!-- Column -->
          <div class="same-height-columns__column">
        <!-- Cover -->        
            Monthly
        <!-- Content -->
            <div class="same-height-columns__content">No minimum commitment. Pause or cancel anytime</div>
        <!-- Button sticks to the bottom -->
            $2999/m
            <div class="line-through">$5998/m</div> 
          </div>
          <div class="same-height-columns__column">
        <!-- Cover -->        
            Quarterly
        <!-- Content -->
            <div class="same-height-columns__content">Save $500 per month</div>
        <!-- Button sticks to the bottom -->
            $2499/m
            <div class="line-through">$4998/m</div> 
          </div>
          <div class="same-height-columns__column">
        <!-- Cover -->        
            Yearly
        <!-- Content -->
            <div class="same-height-columns__content">Save $500 per month</div>
        <!-- Button sticks to the bottom -->
            $1999/m
            <div class="line-through">$3998/m</div> 
          </div>
    <!-- Repeat with other columns -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import * as THREE from "three";
//显示vue之前的网页设置
import { ref, onMounted } from "vue";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { gsap } from "gsap";
//导入控制器
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";


let screenDom = ref(null);
let pages = ref(null);
// let clock = new THREE.Clock();
//vue创建场景相机在onMounted(函数)里
onMounted(() => {
  // 创建场景
  let scene = new THREE.Scene();
  // 创建相机：角度、屏幕宽高比，最近最远的距离
  let camera = new THREE.PerspectiveCamera(
    45,
    window.innerWidth / window.innerHeight,
    0.1,
    100000
  );
  //相机位置（x, y z轴）
  camera.position.set(0, 0, 10);
  // 创建渲染器（将相机看到的内容渲染到画布）
  let renderer = new THREE.WebGLRenderer({   
    // 设置抗锯齿
    antialias: true,
  //   对数深度缓冲区：多个面靠的很近，不知道渲染哪个面导致的闪烁问题
    logarithmicDepthBuffer: true,
  });
  renderer.setSize(window.innerWidth, window.innerHeight);
  // 将画布添加到页面中（通过dom添加到div里面，dom对象追加渲染出来的画布）
  screenDom.value.appendChild(renderer.domElement);

  // // 创建星空的背景（创建纹理把图片加载进来）,创建加载器加载url图片地址，
  // let url = "./assets/25s.jpg";
  // let envTexture = new THREE.TextureLoader().load(url);
  // //纹理的映射是球面的映射（一个立方体6面贴了图）
  // envTexture.mapping = THREE.EquirectangularReflectionMapping;
  // //设置场景和环境的纹理
  // scene.background = envTexture;
  // scene.environment = envTexture;

  // 载入环境纹理hdr  (飞机上面等要添加材质，否则计算会越来越大)
  const hdrLoader = new RGBELoader();
  hdrLoader.loadAsync("./assets/AR01-bigpinkfolwer.hdr").then((texture) => {
    texture.mapping = THREE.EquirectangularReflectionMapping;
    scene.background = texture;
    scene.environment = texture;
  });

  // // 添加球（1张全景图就映射在球上，半径是5）
  // const geometry = new THREE.SphereGeometry(501, 32, 32);
  // const hdrloader = new RGBELoader();
  // hdrloader.load("./assets/sky_.hdr", (texture) => {
  //   const material = new THREE.MeshBasicMaterial({ map: texture });
  //   const sphere = new THREE.Mesh(geometry, material);
  //   //贴的是外面的，z轴反过来，里面才看的见
  //   sphere.geometry.scale(1, 1, -1);
  //   scene.add(sphere);
  // });

  function render() {
    //动画帧函数不断的进行调用（渲染）
    requestAnimationFrame(render);
    // 要看的见场景和环境的纹理就需要渲染出来
    renderer.render(scene, camera);
  }
  render();

    // 添加灯光（3灯，都设置位置）
  let light = new THREE.DirectionalLight(0xffffff, 1);
  light.position.set(0, 0, 1);
  scene.add(light);
  let light2 = new THREE.DirectionalLight(0xffffff, 0.5);
  light2.position.set(0, 0, -1);
  scene.add(light2);
  let light3 = new THREE.AmbientLight(0xffffff, 0.5);
  light3.position.set(-1, 1, 1);
  scene.add(light3);

  // 创建控制器
  let controls = new OrbitControls(camera, renderer.domElement);
  //设置阻尼让控制器更有真实的效果,必须在动画循环里调用.update()
  controls.enableDamping = true;



  //6.监听画面变化，更新渲染画面
window.addEventListener("resize", () => {
    //console.log("画面变化了");
    //更新摄像头
    camera.aspect = window.innerWidth / window.innerHeight;
    //更新摄像机投影矩阵（三维是通过矩阵算法映射到二维里）
    camera.updateProjectionMatrix();
    //更新渲染器
    renderer.setSize(window.innerWidth, window.innerHeight);
    //屏幕像素比率发生变化，设置渲染器像素比,设置成设备的像素比（电脑是1就按1设置，手机是2就按2设置）
    renderer.setPixelRatio(window.devicePixelRatio);
});

  // 设置解压缩的加载器，js的解压器
  let dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath("./draco/gltf/");
  dracoLoader.setDecoderConfig({ type: "js" });
  let loader = new GLTFLoader();
  loader.setDRACOLoader(dracoLoader);

  //加载模型scene.add(加载3个模型：加入场景，设置鼠标监听，设置动画gasp)
  //加载模型首页小岛1
  loader.load("./model/01-island-v2.glb", (gltf) => {
    //加载小岛
    gltf.scene.scale.set(0.3, 0.3, 0.3);
    gltf.scene.position.set(0, 0, 0);
    let island = gltf.scene;
    scene.add(island);

    //小岛转起来
    let time = {
       value: 0,
    };
    gsap.to(time, {
       value: 1,
       duration: 10,
       repeat: -1,
       ease: "linear",
       onUpdate: () => {
        island.rotation.y = time.value * Math.PI * 2;
      },
    });

        //设置鼠标移动互动
    window.addEventListener("mousemove", (e) => {
      //1*2-1=1 x和y轴的移动范围都是-1到1
      let x = (e.clientX / window.innerWidth) * 2 - 1;
      let y = (e.clientY / window.innerHeight) * 2 - 1;
      
      // 动画用gsap时间对象，旋转时间duration, 360度是2pi
      let timeline = gsap.timeline();
      timeline.to(gltf.scene.rotation, {
        duration: 0.5,
        //因为相反所以颠倒xy
        x: y,
        y: x,
        duration: 1,
      });
    });
  });

  //加载小火车
  loader.load("./model/02-cute-airplane.glb", (gltf) => {
    gltf.scene.scale.set(0.002, 0.002, 0.002);
    gltf.scene.position.set(4, 0, 0);
    let train = gltf.scene;
    scene.add(train);

    //小火车跑起来
    let time = {
       value: 0,
    };
    gsap.to(time, {
       value: 1,
       duration: 10,
       repeat: -1,
       ease: "linear",
       onUpdate: () => {
        train.position.x = 6 * Math.cos(time.value * Math.PI * 2);
        train.position.z = 6 * Math.sin(time.value * Math.PI * 2);
      },
    });

        //设置鼠标移动互动
    window.addEventListener("mousemove", (e) => {
      //1*2-1=1 x和y轴的移动范围都是-1到1
      let x = (e.clientX / window.innerWidth) * 2 - 1;
      let y = (e.clientY / window.innerHeight) * 2 - 1;
      
      // 动画用gsap时间对象，旋转时间duration, 360度是2pi
      let timeline = gsap.timeline();
      timeline.to(gltf.scene.rotation, {
        duration: 0.5,
        //因为相反所以颠倒xy
        x: y,
        y: x,
        duration: 1,
      });
    });
  });

  //加载模型2
  loader.load("./model/03-adan.glb", (gltf) => {
    //设置模型的大小和位置（水平是x轴）
    gltf.scene.scale.set(0.01, 0.01, 0.01);
    gltf.scene.position.set(3, -8, 0);
    scene.add(gltf.scene);

    //设置鼠标移动互动
    window.addEventListener("mousemove", (e) => {
      //1*2-1=1 x和y轴的移动范围都是-1到1
      let x = (e.clientX / window.innerWidth) * 2 - 1;
      let y = (e.clientY / window.innerHeight) * 2 - 1;
      
      // 动画用gsap时间对象，旋转时间duration, 360度是2pi
      let timeline = gsap.timeline();
      timeline.to(gltf.scene.rotation, {
        duration: 0.5,
        //因为相反所以颠倒xy
        x: y,
        y: x,
        duration: 1,
      });
    });
  });


  //加载模型3（3个模型垂直放置放在不同的位置，这里是-8）
  loader.load("./model/04-classic-car.glb", (gltf) => {
    gltf.scene.scale.set(150, 150, 150);
    gltf.scene.position.set(3, -16, 0);
    scene.add(gltf.scene);

    window.addEventListener("mousemove", (e) => {
      let x = (e.clientX / window.innerWidth) * 2 - 1;
      let y = (e.clientY / window.innerHeight) * 2 - 1;

      let timeline = gsap.timeline();
      timeline.to(gltf.scene.rotation, {
        duration: 0.5,
        x: y,
        y: x,
        duration: 1,
      });
    });
  });

  //加载模型4
  loader.load("./model/05-headphones.glb", (gltf) => {
    gltf.scene.scale.set(0.2, 0.2, 0.2);
    gltf.scene.position.set(3, -24, 0);
    scene.add(gltf.scene);

    window.addEventListener("mousemove", (e) => {
      let x = (e.clientX / window.innerWidth) * 2 - 1;
      let y = (e.clientY / window.innerHeight) * 2 - 1;

      let timeline = gsap.timeline();
      timeline.to(gltf.scene.rotation, {
        duration: 0.5,
        x: y,
        y: x,
        duration: 1,
      });
    });
  });



  //相机往下走就能看到下一个模型，所以是监听鼠标滚动
  let page = 0;
  //时间线对象可以用来做动画
  let timeline2 = gsap.timeline();
  window.addEventListener("mousewheel", (e) => {
    //当<0时鼠标往下滚
    if (e.wheelDelta < 0) {
      page++;
      if (page > 4) {
        page = 4;
      }
    }
    if (e.wheelDelta > 0) {
      page--;
      if (page < 0) {
        page = 0;
      }
    }

    //1）让相机往下走，位置进行移动；2）类似于防抖如果切的太快，就改成如果timeline2正在活动的阶段就不做这个运动，等活动完之后再做
    if (!timeline2.isActive()) {
      timeline2.to(camera.position, {
        duration: 0.5,
        //移动y轴（因为第二个模型在-8）
        y: page * -8,
        duration: 1,
      });
      //页面也跟着动，直接获取页面对象pages，
      gsap.to(pages.value, {
        duration: 1,
        //y轴移动整个屏幕高度，负号是往上走
        y: -page * window.innerHeight,
        duration: 1,
      });
    }
  });

  //最后放入星星月亮
    loader.load("./model/moon.glb", (gltf) => {
    //加载月亮
    let moon = gltf.scene.children[0];
    //创造1000个月亮，月亮实例化moon Instance
    //制作10个矩阵，不会一下子飞过去
    for (let j = 0; j < 10; j++) {
      let moonInstance = new THREE.InstancedMesh(
        moon.geometry,
        moon.material,
        100
      );

      // scene.add(moon);
      //设置一个循环矩阵，设置矩阵的位置
      for (let i = 0; i < 1000; i++) {
        //math.random是0到1，*1000就是0到1000， -500就是-500到500
        let x = Math.random() * 1000 - 500;
        let y = Math.random() * 1000 - 500;
        let z = Math.random() * 1000 - 500;
        
        //设置一个矩阵包含这些信息（3d物体需要设置位置旋转和缩放）
        let matrix = new THREE.Matrix4();
        //大小也是随机，大小矩阵
        let size = Math.random() * 20 - 8;
        matrix.makeScale(size, size, size);
        matrix.makeTranslation(x, y, z);
        moonInstance.setMatrixAt(i, matrix);
      }
      
      //月亮动起来：当前0的位置移动到-1000，不断重复repeat-1
      gsap.to(moonInstance.position, {
        //速度也是随机值，最小是2（速度太快可增加摄像机最远距离）
        duration: Math.random() * 10 + 2,
        z: -1000,
        //线性运动
        ease: "linear",
        //去掉了duration:1周期是1会覆盖前面的，去掉后速度变慢
        repeat: -1,
      });
      scene.add(moonInstance);
    }
  });

});
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
body {
  background-color: #000;
}
.canvas-container {
  width: 100vw;
  height: 100vh;
}
.home {
  width: 100vw;
  height: 100vh;
  transform-origin: 0 0;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header .logo {
  height: 100px;
  width: 300px;
  background-image: url("./assets/ETDesign.png");
  background-size: 60%;
  background-position: center;
  background-repeat: no-repeat;
}
.canvas-container {
  width: 100%;
  height: 100%;
}
.menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 50px;
}
.menuItem {
  padding: 0 15px;
  text-decoration: none;
  color: #fff;
  font-weight: 900;
  font-size: 15px;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-image: url(./assets/loading.jpg);
  background-size: cover;
  filter: blur(50px);
  z-index: 100;
}
.progress {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 101;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #fff;
}
.progress > img {
  padding: 0 15px;
}

/* .title {
  width: 380px;
  height: 40px;
  position: fixed;
  right: 100px;
  top: 50px;
  background-color: rgba(0, 0, 0, 0.5);
  line-height: 40px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  z-index: 110;
} */
.pages {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
}
.pages .page1 {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  padding: 15%;
  box-sizing: border-box;
}
.pages .page1 .title {
  font-size: 50px;
  font-weight: 900;
  margin-top: 80px;
  /* margin-bottom: 20px */
  color: #fff;
}
.pages .page1 p {
  font-size: 25px;
}
.pages .page {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: #fff;
  padding: 15%;
  box-sizing: border-box;
}
.pages .page .title {
  font-size: 50px;
  font-weight: 900;
  margin-bottom: 20px;
}
.pages .page p {
  font-size: 25px;
}
.pages .page video {
  font-size: 25px;
  width: 1000px;

}

.pages .page .same-height-columns {
    display: flex;
}

.pages .page .same-height-columns__column {
    flex: 1;
    /* Space between columns */
    margin: 0 8px;

    /* Layout each column */
    display: flex;
    flex-direction: column;
}

.pages .page .same-height-columns__content {
    /* Take available height */
    flex: 1;
}

.pages .page .line-through {
  text-decoration:line-through
}

.pages .page .content_video .video-js .vjs-big-play-button {
    font-size: 1.5em ;
    width: 2.5em;
    border-radius: 50%;
    top: 40%;
    left: 45%;
  }
  .content_video {
    text-align: left;
    padding: 0 7%;
  }

</style>
